import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Map config key → env var name (for friendlier error messages)
const ENV_NAME: Record<keyof typeof config, string> = {
  apiKey: 'VITE_FIREBASE_API_KEY',
  authDomain: 'VITE_FIREBASE_AUTH_DOMAIN',
  projectId: 'VITE_FIREBASE_PROJECT_ID',
  storageBucket: 'VITE_FIREBASE_STORAGE_BUCKET',
  messagingSenderId: 'VITE_FIREBASE_MESSAGING_SENDER_ID',
  appId: 'VITE_FIREBASE_APP_ID',
};

// Fail fast with a clear, visible message when env vars are missing — much
// friendlier than Firebase's "auth/invalid-api-key" deep stack trace.
const missing = (Object.keys(config) as Array<keyof typeof config>)
  .filter((k) => !config[k])
  .map((k) => ENV_NAME[k]);

if (missing.length > 0) {
  const msg =
    `Firebase config missing. Falta llenar en app/.env:\n  - ${missing.join('\n  - ')}\n\n` +
    `Después reinicia con:  make down && make up`;
  if (typeof document !== 'undefined') {
    document.body.innerHTML =
      `<pre style="padding:24px;font-family:ui-monospace,monospace;color:#b91c1c;` +
      `white-space:pre-wrap;background:#fef2f2;border:1px solid #fecaca;` +
      `border-radius:8px;margin:24px;">${msg}</pre>`;
  }
  throw new Error(msg);
}

export const firebaseApp: FirebaseApp = initializeApp(config);
export const firebaseAuth: Auth = getAuth(firebaseApp);
